// When a home page tile shows its picture and when it shows its text (TOM-980).
//
// A mouse opens a tile on hover and closes it on leave. A tap or a pen press
// toggles it. Enter and Space fire a click with detail 0, which toggles it. A
// mouse click does nothing, because hover already opened the tile. Touch and pen
// ignore hover. This is the approved design's rule, written as a reducer over
// the pointer and click events a tile receives.

export interface TileState {
  open: boolean;
  /** The pointer type of the last pointerdown on the tile. */
  lastPointer: string;
}

export interface TileEvent {
  type: string;
  pointerType?: string;
  /** A click's detail: 0 when a key fired it. */
  detail?: number;
}

export const TILE_CLOSED: TileState = { open: false, lastPointer: 'mouse' };

/** The tile's state after an event. Returns the same object when nothing changes. */
export function flipTile(state: TileState, event: TileEvent): TileState {
  switch (event.type) {
    case 'pointerdown': {
      const lastPointer = event.pointerType || 'mouse';
      return lastPointer === state.lastPointer ? state : { ...state, lastPointer };
    }
    case 'pointerenter':
    case 'pointerleave': {
      if (event.pointerType !== 'mouse') return state;
      const open = event.type === 'pointerenter';
      return open === state.open ? state : { ...state, open };
    }
    case 'click': {
      const fromKey = event.detail === 0;
      if (!fromKey && state.lastPointer === 'mouse') return state;
      return { ...state, open: !state.open };
    }
    default:
      return state;
  }
}

/** The line above each tile grid, for a device that can hover or one that cannot. */
export function tileHint(canHover: boolean): string {
  return canHover ? 'Hover over a picture to learn more' : 'Tap a picture to learn more';
}
